import * as React from "react"

const GooglePlay = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <title>google-play</title>
    <path d="M20.18323,10.8874,16.904,9.02788l-2.99628,2.97191,2.988,2.98022c1.003-.81431,6.07524-2.39432,3.27927-4.10091ZM13.092,12.82994l-9.15532,9.1316c.21549.61112,11.46038-6.26073,11.88526-6.36722ZM3.10441,2.86819C2.87014,3.88781,3.116,19.66762,3.02931,20.576a1.918,1.918,0,0,0,.0751.55537l9.15532-9.1316Zm.8323-.83014C4.15113,1.43056,15.39935,8.29739,15.822,8.40526l-2.73826,2.76439Z" />
  </svg>
)

export default GooglePlay
